import { render, staticRenderFns } from "./GerenciarProgramas.vue?vue&type=template&id=700fbbd0&scoped=true"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "./GerenciarProgramas.vue?vue&type=style&index=0&id=700fbbd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700fbbd0",
  null
  
)

export default component.exports